document.addEventListener("DOMContentLoaded", function () {
  const searchIcons = document.querySelectorAll(".ek-searchIcon");

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.activeTab = "products"; // Default active tab
      this.results = {
        products: [],
        articles: [],
        queries: [],
      };
      this.observer = null;
      this.hideUpsellAndCollections = false;
    }

    connectedCallback() {
      this.input = this.querySelector("#predictiveSearch");
      this.predictiveSearchResults = this.querySelector("#predictive-search-results");
      this.resultsLengthElement = this.querySelector("#resultsLength");
      this.viewAllLink = this.resultsLengthElement?.closest("a");
      this.searchForm = this.querySelector("form");
      this.promotedWords = this.querySelectorAll(".promotedWord");
      this.backIconSearch = this.querySelector("#backIconSearch");
      this.closeSearchModal = this.querySelector("#closeSearchModal");
      this.closeSearchForm = this.querySelectorAll(".closeSearchForm");
      this.modal = this.closest(".fixed");
      this.searchModal = document.getElementById("ek-searchModalPanel");
      this.emptySearchUpsell = this.querySelector("#emptySearchUpsell");
      this.featuredCollectionsSearch = this.querySelector("#featuredCollectionsSearch");

      if (!this.input) {
        return;
      }

      this.hideUpsellAndCollections = this.isHideUpsellVariant();

      if (this.hideUpsellAndCollections) {
        if (this.emptySearchUpsell) this.emptySearchUpsell.classList.add("hidden");
        if (this.featuredCollectionsSearch) this.featuredCollectionsSearch.classList.add("hidden");
        this.classList.remove("h-[90dvh]", "pb-0");
        this.classList.add("pb-3");
      }

      if (searchIcons && this.modal) {
        searchIcons.forEach((searchIcon) => {
          searchIcon.addEventListener("click", () => {
            this.openModal(); // Use component method to show modal
            this.input.focus(); // Optional: focus the input when opening
          });
        });
      }

      this.toggleBackArrow(this.getQuery());

      this.setupEventListeners();
      this.setupMutationObserver();
    }

    isHideUpsellVariant() {
      return false;
    }

    openModal() {
      if (this.modal) {
        this.modal.classList.remove("hidden");
        document.body.classList.add("no-scroll");

        setTimeout(() => {
          this.modal.classList.remove("opacity-0");
          this.searchModal.classList.remove("translate-y-[15%]");
        }, 100);
      }
    }

    closeModal() {
      if (this.modal) {
        this.modal.classList.add("opacity-0");
        this.searchModal.classList.add("translate-y-[15%]");
        document.body.classList.remove("no-scroll"); // Restore scrolling
        setTimeout(() => {
          this.modal.classList.add("hidden"); // Add hidden class
          this.resetSearch();
        }, 300);
      }
    }

    toggleBackArrow(searchTerm) {
      if (!this.backIconSearch) return;

      if (searchTerm.length > 0) {
        this.backIconSearch.classList.add("!w-0", "opacity-0");
        this.backIconSearch.classList.remove("hidden");
        setTimeout(() => {
          this.backIconSearch.classList.remove("!w-0", "opacity-0");
          this.backIconSearch.classList.add("border-r");
        }, 0);
      } else {
        this.backIconSearch.classList.add("!w-0", "opacity-0");
        this.backIconSearch.classList.remove("border-r");
        setTimeout(() => {
          this.backIconSearch.classList.add("hidden");
        }, 150);
      }
    }

    resetSearch() {
      // Clear the input value
      this.input.value = "";

      // Close the search results
      this.close();

      // Update the back arrow visibility (should hide it since input is empty)
      this.toggleBackArrow("");

      // Reset the results object to initial state
      this.results = {
        products: [],
        articles: [],
        queries: [],
      };

      if (this.searchModal) {
        this.searchModal.classList.add("!h-auto");
      }

      const emptySearchUpsell = this.querySelector("#emptySearchUpsell");
      if (emptySearchUpsell) {
        emptySearchUpsell.classList.remove("hidden");
      }

      if (this.emptySearchUpsell) {
        if (this.hideUpsellAndCollections) {
          this.emptySearchUpsell.classList.add("hidden");
        } else {
          this.emptySearchUpsell.classList.remove("hidden");
        }
      }

      // Focus back on the input
      this.input.focus();
    }

    setupEventListeners() {
      if (this.backIconSearch) {
        this.backIconSearch.addEventListener("click", () => {
          const searchTerm = this.getQuery();
          if (searchTerm.length > 0) {
            this.input.value = "";
            this.toggleBackArrow(""); // Update back arrow visibility
            this.resetSearch();
          }
        });
      }

      this.input.addEventListener(
        "input",
        this.debounce((event) => {
          const searchTerm = this.getQuery();
          this.toggleBackArrow(searchTerm); // Update back arrow visibility
          this.onChange(event);
        }, 300),
      );

      this.input.addEventListener("focus", this.onFocus.bind(this));

      // Handle tab clicks
      this.addEventListener("click", (event) => {
        const tabElement = event.target.closest("[data-tab]");
        if (tabElement) {
          const tabName = tabElement.dataset.tab;
          this.switchTab(tabName);
          event.preventDefault();
        }
      });

      // Handle keyboard navigation
      this.addEventListener("keydown", this.handleKeyboardNavigation.bind(this));

      // Global escape key listener to close modal
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && this.modal && !this.modal.classList.contains("hidden")) {
          this.closeModal();
          event.preventDefault();
        }
      });

      // Click outside modal to close
      if (this.modal) {
        this.modal.addEventListener("click", (event) => {
          // Check if the click is on the modal backdrop (not on the modal content)
          if (event.target === this.modal) {
            this.closeModal();
          }
        });
      }

      this.promotedWords.forEach((button) => {
        button.addEventListener("click", () => {
          const searchTerm = button.textContent.trim();
          this.input.value = searchTerm;
          this.toggleBackArrow(searchTerm); // Update back arrow when promoted word is clicked
          this.onChange();
        });
      });
      if (this.closeSearchModal) {
        this.closeSearchModal.addEventListener("click", () => {
          this.closeModal();
        });
      }

      if (this.closeSearchForm) {
        this.closeSearchForm.forEach((button) => {
          button.addEventListener("click", () => {
            this.closeModal();
          });
        });
      }
    }

    handleKeyboardNavigation(event) {
      // Only handle keyboard navigation when results are open
      if (!this.isOpen) return;

      const focusableElements = this.querySelectorAll(".predictive-search__item-link");
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const tabElements = this.querySelectorAll("[data-tab]");

      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          this.navigateInList(focusableElements, "forward");
          break;
        case "ArrowUp":
          event.preventDefault();
          this.navigateInList(focusableElements, "backward");
          break;
        case "Tab":
          if (!event.shiftKey && document.activeElement === lastElement) {
            tabElements[0].focus();
            event.preventDefault();
          } else if (event.shiftKey && document.activeElement === firstElement) {
            tabElements[tabElements.length - 1].focus();
            event.preventDefault();
          }
          break;
        case "Escape":
          this.close();
          this.closeModal(); // Close the entire modal
          event.preventDefault();
          break;
      }
    }

    navigateInList(elements, direction) {
      const currentIndex = Array.from(elements).findIndex((el) => el === document.activeElement);
      let nextIndex;

      if (currentIndex === -1) {
        nextIndex = direction === "forward" ? 0 : elements.length - 1;
      } else {
        nextIndex = direction === "forward" ? (currentIndex + 1) % elements.length : (currentIndex - 1 + elements.length) % elements.length;
      }

      elements[nextIndex].focus();
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) {
        this.resetSearch();
        this.close();
        return;
      }

      if (this.searchModal) {
        this.searchModal.classList.remove("!h-auto");
      }

      this.showLoadingState();
      this.getSearchResults(searchTerm);

      // Use stored property and respect A/B test condition
      if (this.emptySearchUpsell) {
        if (this.hideUpsellAndCollections) {
          this.emptySearchUpsell.classList.add("hidden");
        } else {
          if (searchTerm.length > 0) {
            this.emptySearchUpsell.classList.add("hidden");
          } else {
            this.emptySearchUpsell.classList.remove("hidden");
          }
        }
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();
      this.onChange();
      if (!searchTerm.length) return;

      if (this.isOpen) {
        this.open();
      } else {
        this.showLoadingState();
        this.getSearchResults(searchTerm);
      }
    }

    showLoadingState() {
      if (!this.predictiveSearchResults) return;

      // Create a new structure with sticky tabs
      this.predictiveSearchResults.innerHTML = `
          <div class="predictive-search__container">
            <div class="predictive-search__loading flex items-center justify-center p-8">
              <svg class="animate-spin h-6 w-6 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span class="ml-2">Suchen...</span>
            </div>
          </div>
        `;
      this.open();
    }

    async getSearchResults(searchTerm) {
      try {
        // Add resources=article,product,query to get all necessary result types
        const url = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[limit]=10&resources[limit_scope]=each&unavailable_products=hide&section_id=predictive-search`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Search request failed: ${response.status}`);
        }

        const data = await response.json();

        if (!this.input.value.includes(searchTerm)) return;

        // Store the results
        const rawProducts = data.resources?.results?.products || [];
        const articles = data.resources?.results?.articles || [];
        const queries = data.resources?.results?.queries || [];

        const filteredProducts = rawProducts.filter((product) => {
          if (product.title.includes("B-Ware")) {
            return product.available === true;
          }
          if (product.tags.includes("exclude_from_search")) {
            return false;
          }
          return true;
        });

        this.results = {
          products: filteredProducts,
          articles: articles,
          queries: queries,
        };

        // Calculate total results
        const totalProducts = this.results.products.length;
        const totalArticles = this.results.articles.length;

        // Update the view all link URL
        if (this.viewAllLink) {
          this.viewAllLink.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(searchTerm)}`;
        }
        // If no results in either category, close the search
        if (totalProducts === 0 && totalArticles === 0) {
          this.renderNoResults();
          return;
        }

        // If current tab has no results but other tab does, switch tabs
        if (this.activeTab === "products" && totalProducts === 0 && totalArticles > 0) {
          this.activeTab = "articles";
        } else if (this.activeTab === "articles" && totalArticles === 0 && totalProducts > 0) {
          this.activeTab = "products";
        }

        this.renderSearchResults();
      } catch (error) {
        this.renderErrorState(error);
      }
    }

    renderErrorState(error) {
      // Structure with sticky header
      this.predictiveSearchResults.innerHTML = `
          <div class="predictive-search__error p-4 text-center">
            <p class="text-red-500">Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.</p>
            <p class="text-sm text-gray-500">${error.message}</p>
          </div>
        `;
      this.open();
    }

    renderNoResults() {
      this.predictiveSearchResults.innerHTML = `
          <div class="predictive-search__no-results p-4 text-center">
            <p class="text-gray-500">Leider konnten wir keine Ergebnis für den Suchbegriff <b>"${this.getQuery()}"</b> finden.</p>
          </div>
        `;

      // Hide the view all results button
      if (this.viewAllLink && this.viewAllLink.closest("div")) {
        this.viewAllLink.closest("div").style.display = "none";
      }

      // Use stored property and respect A/B test condition
      if (this.featuredCollectionsSearch) {
        if (this.hideUpsellAndCollections) {
          this.featuredCollectionsSearch.classList.add("hidden");
        } else {
          this.featuredCollectionsSearch.classList.remove("hidden");
        }
      }

      this.open();
    }

    renderSearchResults() {
      const { products, articles, queries } = this.results;
      const totalProducts = products.length;
      const totalArticles = articles.length;

      if (this.featuredCollectionsSearch) {
        this.featuredCollectionsSearch.classList.add("hidden");
      }

      // Show the view all results container if we have results
      if (this.viewAllLink && this.viewAllLink.closest("div")) {
        this.viewAllLink.closest("div").style.display = "flex";
      }

      // Start building the markup with query suggestions
      let querySuggestionsMarkup = "";
      if (queries && queries.length > 0) {
        querySuggestionsMarkup = `
            <div class="predictive-search__query-suggestions mb-4">
              <h3 class="text-sm font-medium text-gray-500 mb-2 px-4">MEINTEST DU</h3>
              <ul class="px-4">
                ${queries
                  .slice(0, 3)
                  .map(
                    (query) => `
                  <li class="mb-1">
                    <a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(query.text)}" class="block py-1 hover:text-gray-900">
                      ${query.text}
                    </a>
                  </li>
                `,
                  )
                  .join("")}
              </ul>
            </div>
          `;
      }

      // Restructure the predictive search results with a sticky header for tabs
      this.predictiveSearchResults.innerHTML = `
          <div class="predictive-search__container flex flex-col">
            <!-- Query suggestions section -->
            ${querySuggestionsMarkup}

            <!-- Sticky tabs section -->
            <div class="predictive-search__tabs-container sticky top-0 bg-white z-10">
              <div class="predictive-search__tabs flex px-4 gap-10">
                <button data-tab="products" class="pt-3 pb-1 font-body text-sm font-normal tracking-wider uppercase leading-[155%] relative ${this.activeTab === "products" ? "after:h-[2px] after:w-full after:bg-black after:rounded-full after:absolute after:-bottom-1 after:left-0 after:right-0" : "text-gray-500"}">
                  PRODUKTE ${totalProducts > 0 ? `(${totalProducts})` : ""} 
                </button>
                <button data-tab="articles" class="pt-3 pb-1 font-body text-sm font-normal tracking-wider uppercase leading-[155%] relative ${this.activeTab === "articles" ? "after:h-[2px] after:w-full after:bg-black after:rounded-full after:absolute after:-bottom-1 after:left-0 after:right-0" : "text-gray-500"}">
                  MAGAZIN ${totalArticles > 0 ? `(${totalArticles})` : ""}
                </button>
              </div>
            </div>

            <!-- Scrollable content section -->
            <div class="predictive-search__content overflow-auto no-scrollbar max-h-full">
              ${
                this.activeTab === "products"
                  ? totalProducts > 0 // Check if there are filtered products for this tab
                    ? this.renderProductResults(products) // Render them if yes
                    : '<div class="p-8 text-center text-gray-500">Keine passenden Produkte gefunden.</div>' // Show specific message if no
                  : this.activeTab === "articles"
                    ? totalArticles > 0 // Check articles
                      ? this.renderArticleResults(articles)
                      : '<div class="p-8 text-center text-gray-500">Keine Magazinartikel gefunden.</div>' // Specific message for articles
                    : '<div class="p-8 text-center text-gray-500">Keine Ergebnisse gefunden</div>' // Fallback (shouldn't be reached if logic is correct)
              }
            </div>
          </div>
        `;

      this.open();
    }

    getCurrencySymbol() {
      const country = window.Shopify && window.Shopify.country;
      // Switzerland uses CHF, all other markets use EUR
      return country === "CH" ? "CHF" : "€";
    }

    renderProductResults(products) {
      const currencySymbol = this.getCurrencySymbol();

      return `
          <div class="predictive-search__products lg:grid lg:grid-cols-2 lg:gap-x-4" role="listbox" aria-labelledby="predictive-search-products">
          ${products // Use the already filtered list here
            .map((product, index) => {
              // Split title logic similar to Liquid
              const splittedTitle = product.title.split(" | ");
              const mainTitle = splittedTitle[0];
              const correctSubtitle = splittedTitle.length > 1 ? splittedTitle.slice(1).join(" | ") : "";

              return `
              <div class="predictive-search__list-item relative after:w-[calc(100%_-_30px)] after:h-[1px] after:bg-lightgray after:absolute after:bottom-0 after:left-1/2 after:transform after:-translate-x-1/2 after:rounded-full last:after:hidden lg:[&:nth-last-child(-n+2)]:after:hidden py-2 last:border-none" role="option" ${
                index === 0 ? 'aria-selected="true"' : ""
              }>
                <a href="${product.url}" class="predictive-search__item-link flex items-stretch gap-2 items-center p-4">
                  ${
                    product.featured_image
                      ? `
                    <img
                      src="${product.featured_image.url}"
                      class="w-20 md:w-28 mr-[10px]"
                      loading="lazy"
                      width="300"
                      height="350"
                      alt="${product.title}"
                    >
                  `
                      : ""
                  }
                  <div class="flex-1 flex flex-col gap-1">
                    <h3 class=" md:text-base active:text-berry hover:text-berry max-w-48 md:max-w-none mb-auto ">${mainTitle} <br> ${correctSubtitle ? `<span class="block font-normal">${correctSubtitle}</span>` : ""}</h3>
                    <p class="text-md text-secondaryhighlight">${product.price_min.replace(".", ",")}${
                      product.price_min !== product.price_max ? " - " + product.price_max.replace(".", ",") : ""
                    } ${currencySymbol}</p>
                  </div>
                  <div class="mt-auto">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-auto mb-0 block">
                      <path d="M26 13C26 5.82031 20.1797 8.65466e-06 13 8.9685e-06C5.8203 9.28233e-06 -8.82082e-07 5.82031 -5.68248e-07 13C-2.54413e-07 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13Z" fill="#F2F2F2"/>
                      <path d="M18.22 13.8L12.72 8.94L13.64 7.84L19.68 13.06L18.22 13.8ZM7.36 13.78V12.32L18.36 12.32V13.78L7.36 13.78ZM13.62 18.24L12.7 17.14L18.22 12.3L19.68 13.06L13.62 18.24Z" fill="#808080"/>
                    </svg>
                  </div>
                </a>
              </div>
            `;
            })
            .join("")}
          </div>
        `;
    }

    renderArticleResults(articles) {
      if (!articles.length) return '<div class="p-4 text-center text-gray-500">Keine Magazinartikel gefunden</div>';

      return `
          <div class="predictive-search__articles mt-4" role="listbox" aria-labelledby="predictive-search-articles">
            ${articles
              .map(
                (article, index) => `
              <div class="predictive-search__article-item relative after:w-[calc(100%_-_30px)] after:h-[1px] after:bg-lightgray after:absolute after:bottom-0 after:left-1/2 after:transform after:-translate-x-1/2 after:rounded-full last:after:hidden py-3 last:border-none" role="option" ${index === 0 ? 'aria-selected="true"' : ""}>
                <a href="${article.url}" class="predictive-search__item-link flex items-start px-4 gap-4">
                  ${
                    article.featured_image
                      ? `
                          <img
                              src="${article.featured_image.url}"
                              class="w-20 md:w-28"
                              loading="lazy"
                              width="300"
                              height="350"
                              alt="${article.title}"
                            >
                  `
                      : ""
                  }
                  <div class="flex-1 h-full flex flex-col justify-between"">
                    <h3 class="font-normal font-display md:heading-4">${article.title}</h3>
                  </div>
                  <div class="mt-auto mb-0">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-auto mb-0 block">
                    <path d="M26 13C26 5.82031 20.1797 8.65466e-06 13 8.9685e-06C5.8203 9.28233e-06 -8.82082e-07 5.82031 -5.68248e-07 13C-2.54413e-07 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13Z" fill="#F2F2F2"/>
                    <path d="M18.22 13.8L12.72 8.94L13.64 7.84L19.68 13.06L18.22 13.8ZM7.36 13.78V12.32L18.36 12.32V13.78L7.36 13.78ZM13.62 18.24L12.7 17.14L18.22 12.3L19.68 13.06L13.62 18.24Z" fill="#808080"/>
                    </svg>
                  </div>
                </a>
              </div>
            `,
              )
              .join("")}
          </div>
        `;
    }

    switchTab(tabName) {
      if (tabName === this.activeTab) return;

      this.activeTab = tabName;
      this.renderSearchResults();

      // Focus on first result in the new tab
      setTimeout(() => {
        const firstResult = this.querySelector(".predictive-search__item-link");
        if (firstResult) firstResult.focus();
      }, 100);
    }

    setupMutationObserver() {
      if (!this.modal) return;

      // Check initial state and apply no-scroll if modal is visible
      if (this.modal.style.display !== "none" && getComputedStyle(this.modal).display !== "none") {
        document.body.classList.add("no-scroll");
      }

      // Create and configure the MutationObserver
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "style") {
            const isVisible = this.modal.style.display !== "none" && getComputedStyle(this.modal).display !== "none";
            if (isVisible) {
              document.body.classList.add("no-scroll");
            } else {
              document.body.classList.remove("no-scroll");
            }
          }
        });
      });

      // Observe changes to the modal's style attribute
      this.observer.observe(this.modal, {
        attributes: true,
        attributeFilter: ["style"], // Only watch for style changes
      });
    }

    // Clean up the observer when the element is removed from the DOM
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      document.body.classList.remove("no-scroll"); // Ensure scrolling is restored
    }

    open() {
      // Apply any custom styling needed for showing results
      this.input.setAttribute("aria-expanded", true);
      this.isOpen = true;
    }

    close() {
      this.input.setAttribute("aria-expanded", false);
      this.isOpen = false;

      // Clear the results
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.innerHTML = "";
      }

      // Hide the "X results" button
      if (this.viewAllLink && this.viewAllLink.closest("div")) {
        this.viewAllLink.closest("div").style.display = "none";
      }

      if (this.featuredCollectionsSearch) {
        this.featuredCollectionsSearch.classList.add("hidden");
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define("predictive-search", PredictiveSearch);
});
